import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  Alert,
  AlertsService,
  LevelType,
  MessageType,
  PxModalMessageService,
} from '@proximus/ng-common-components';
import {
  ApplicationState,
  getProductDetailsTechnicalError,
  getSelectedProductDetails,
} from '../../../../../store/reducers';
import { TranslationService } from '@proximus/ng-common';
import { OnDestroyHookDirective } from '../../../../../shared/hooks';
import { Router } from '@angular/router';
import {
  MobileProduct,
  Option,
  OptionStatus,
} from '@dch/products-business-logic';
import { getPiiServiceId } from 'src/app/shared/pii/pii.utils';
import { GetProductDetails } from '../../../../../store/actions/product-details.actions';
import { getDescriptionMessage } from 'src/app/shared/order-utils/order-utils';
import { WebshopUtils } from '../../../../../shared/webshop/webshop-utils';

const FLEX_EMERGENCY_MPCUUID = 'MEGMK';

@Component({
  selector: 'mprd-flex-emergency-activation-pxsplus',
  templateUrl: './flex-emergency-activation-pxsplus.component.html',
})
export class FlexEmergencyActivationPxsplusComponent
  extends OnDestroyHookDirective
  implements OnInit
{
  selectedProduct: MobileProduct;
  hasError = false;
  orderButtonsDisabled = false;
  selectedOption: Option;

  constructor(
    private router: Router,
    private store: Store<ApplicationState>,
    private translationService: TranslationService,
    private alertService: AlertsService,
    private pxModalMessageService: PxModalMessageService,
  ) {
    super();
  }

  ngOnInit(): void {
    const serviceId = getPiiServiceId();
    if (serviceId) {
      this.addSubscription(
        this.store.select(getSelectedProductDetails).subscribe((value) => {
          if (value && value.mobileProductDetails) {
            this.selectedProduct = value.mobileProductDetails;
            this.getFlexEmergencyOption();
            WebshopUtils.publishCartRetrival(
              this.selectedProduct.installationId,
              this.selectedProduct.accessNumber,
              this.selectedProduct.plc,
            );
          }
        }),
      );

      this.addSubscription(
        this.store
          .select(getProductDetailsTechnicalError)
          .subscribe((value) => {
            this.hasError = value !== undefined && value != null;

            if (!this.selectedProduct && this.hasError) {
              this.displayErrorMessage();
            }
          }),
      );

      this.store.dispatch(
        new GetProductDetails({
          productType: 'mobile',
          serviceId,
        }),
      );
    } else {
      this.hasError = true;
      this.displayErrorMessage();
    }
  }

  onResult(event) {
    if (event && event.orderingInProgress) {
      this.orderButtonsDisabled = true;
    } else if (event && event.type && event.type === 'success') {
      if (event.action && event.action === 'add') {
        this.dispatchAlert(
          event.type,
          this.translationService.getTranslatedValueFor(
            'message.confirmation.title',
          ),
          this.translationService.getTranslatedValueFor(
            'message.confirmation.description',
          ),
          true,
        );
        this.orderButtonsDisabled = false;
        this.routeToStep4();
      }
    } else if (event && event.type && event.type === 'error') {
      this.dispatchAlert(
        'error',
        this.translationService.getTranslatedValueFor('message.error.title'),
        getDescriptionMessage(event, this.translationService),
        true,
      );
      this.orderButtonsDisabled = false;
    }
  }

  private getFlexEmergencyOption() {
    if (this.selectedProduct) {
      if (this.selectedProduct.options) {
        this.selectedOption = this.selectedProduct.options.find(
          (option: Option) =>
            option.optionCodeForDescription === FLEX_EMERGENCY_MPCUUID &&
            option.ibStatus === OptionStatus.AVAILABLE,
        );
      }
    }
  }

  private dispatchAlert(
    type: 'error' | 'info' | 'success' | 'warning',
    title: string,
    description: string,
    isClosable: boolean,
  ): void {
    const alert: Alert = {
      isClosable,
      alertKey: 'flexEmergencyAlert',
      title,
      description,
      type,
    };
    this.alertService.dispatchAlert(alert);
  }

  private routeToStep4() {
    this.router.navigate(['/pxsplus/flex-emergency-confirmation']);
  }

  routeToStep1(): void {
    this.router.navigate(['/pxsplus/flex-emergency-entry']);
  }

  private displayErrorMessage() {
    this.pxModalMessageService.dispatchMessage(
      MessageType.Error,
      LevelType.Root,
      this.translationService.getTranslatedValueFor(
        'mobile.options.pxsplus.error.message',
      ),
      this.translationService.getTranslatedValueFor('message.error.title'),
      false,
      false,
      'backendError',
    );
  }
}
